import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend as ChartJSLegend,
  Filler,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip
} from 'chart.js';

export function initializeChartjs() {
  ChartJS.register(
    ArcElement,
    Tooltip,
    Title,
    Filler,
    ChartJSLegend,
    CategoryScale,
    LineElement,
    PointElement,
    LinearScale,
    BarElement,
    BarController
  );
}
